
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';

import { SharedService } from '@services/shared.service';


import { FormBase } from '@shared/form-base.component';
import { CustomerModel } from '@models/CustomerModel';
import { Country, IdCardCustomerType } from '@models/Enums';
import { ApiAuthService } from '@services/api-auth.service';
import { GeoDataStructure, IGeoDataStructure } from '@shared/geo-data';

@Component({
    selector: 'app-register-account-form',
    templateUrl: './register-account-form.component.html',
    styleUrls: ['./register-account-form.component.scss']
})
export class RegisterAccountFormComponent extends FormBase<UntypedFormGroup> implements OnInit {

    @Input() user: CustomerModel;

    registerForm: UntypedFormGroup;
    dynamicMask: string = 'AAAAAAAAAAAAAAA';
    dynamicType: string = 'text';
    validPhone: boolean = true;
    allYears: number[];
    allMonths: string[];
    dayList: number[];

    geoDataStructure: IGeoDataStructure[] = [];
    geoData: any;
    filteredData: any = {};

    // BsDatepicker config
    bsConfig: Partial<BsDatepickerConfig> = Object.assign({
        containerClass: 'theme-dark-blue',
        rangeInputFormat: 'DD/MM/YYYY',
        showWeekNumbers: false,
        displayMonths: 1,
        // minDate: this.model.endDate,
        // maxDate: new Date(2018, 9, 31),
    }, { containerClass: 'theme-green', dateInputFormat: 'DD/MM/YYYY' });

    constructor(public sharedService: SharedService, private formBuilder: UntypedFormBuilder, private localeService: BsLocaleService,
        private apiAuthService: ApiAuthService) {
        super();

        // Config the datepicker locate to spanish
        this.localeService.use('es');
    }

    ngOnInit(): void {

        const session = this.apiAuthService.getSession();

        if (session?.user) {

            this.geoDataStructure = GeoDataStructure.country(this.user.country);
            this.geoData = GeoDataStructure.countryData(this.user.country);

            this.geoDataStructure.forEach((field, index) => {

                this.filteredData[field.key] = index === 0 ? this.geoData[field.key] : [this.geoData[field.key][0]];
            });

            this._formInit();
        }

        if (session.user.phone == null || session.user.phone == "") {

            this.validPhone = false;
            this.phone.setValidators([]);
            this.phone.setValidators([Validators.required, Validators.minLength(8)]);
        }

        this.sharedService.setHideHamburgerMenu(true);
    }

    onSelect(levelKey: string, selectedValue: string): void {

        const selectedId = parseInt(selectedValue, 10);

        const currentLevelIndex = this.geoDataStructure.findIndex(field => field.key === levelKey);

        this.registerForm.get(levelKey)?.setValue(selectedId);

        // filter the inferior levels
        this.geoDataStructure.slice(currentLevelIndex + 1).forEach((nextField, nextIndex) => {

            if (nextField.ordinal === 2) {//filter the second level

                //filter by first level
                this.filteredData[nextField.key] = this.geoData[nextField.key].filter(x => x.provinceId === this.registerForm.get(this.geoDataStructure[0].key)?.value);

            } else if (nextField.ordinal === 3) { //filter the third level

                //filter by first and second level
                this.filteredData[nextField.key] = this.geoData[nextField.key].filter(x =>
                    (x.provinceId === this.registerForm.get(this.geoDataStructure[0].key)?.value && x.cantonId === this.registerForm.get(this.geoDataStructure[1].key)?.value)
                );
            }

            this.registerForm.get(nextField.key)?.setValue(1);
        });
    }

    onSubmit(): void {

        // if is invalid, show the form errors
        if (this.registerForm.invalid) {

            this.touched = false;
            return;
        }

        if (Number(this.registerForm.controls.birthYear.value) < 2015) {

            this.onSave.emit(this.registerForm);
        } else {

            const errMsg = 'El año ingresado en la fecha de nacimiento debe ser menor al 2015.';
            this.sharedService.showErrorAlert(null, errMsg);

        }
        /* // Valid year
        if (Number(this.registerForm.controls.birthYear.value) < 2015) {

            const registerModel = new RegisterAccountModel();
            registerModel.firstName = this.registerForm.controls.firstName.value;
            registerModel.lastName = this.registerForm.controls.lastName.value;
            registerModel.genderType = this.registerForm.controls.genderType.value;
            registerModel.idCardType = this.registerForm.controls.idCardType.value;
            registerModel.idCard = this.registerForm.controls.idCard.value;
            registerModel.phone = this.registerForm.controls.phone.value;
            registerModel.birthDate = new Date(new Date(Number(this.registerForm.controls.birthYear.value), Number(this.registerForm.controls.birthMonth.value) - 1, Number(this.registerForm.controls.birthDay.value)));

            this.onSave.emit(registerModel);
        }
        else {

            const errMsg = 'El año ingresado en la fecha de nacimiento debe ser menor al 2015.';
            this.sharedService.showErrorAlert(null, errMsg);
        } */
    }

    // Form

    get firstName() { return this._formGet(this.registerForm, 'firstName'); }
    get invalidFirstName(): boolean {
        return this._isInvalid(this.registerForm, 'firstName', this.touched);
    }

    get lastName() { return this._formGet(this.registerForm, 'lastName'); }
    get invalidLastName(): boolean {
        return this._isInvalid(this.registerForm, 'lastName', this.touched);
    }

    get genderType() { return this._formGet(this.registerForm, 'genderType'); }
    get invalidGenderType(): boolean {
        return this._isInvalid(this.registerForm, 'genderType', this.touched);
    }

    get idCardType() { return this._formGet(this.registerForm, 'idCardType'); }
    get invalidIdCardType(): boolean {
        return this._isInvalid(this.registerForm, 'idCardType', this.touched);
    }

    get birthDay() { return this._formGet(this.registerForm, 'birthDay'); }
    get invalidBirthDay(): boolean {
        return this._isInvalid(this.registerForm, 'birthDay', this.touched);
    }

    get birthMonth() { return this._formGet(this.registerForm, 'birthMonth'); }
    get invalidBirthMonth(): boolean {
        return this._isInvalid(this.registerForm, 'birthMonth', this.touched);
    }

    get birthYear() { return this._formGet(this.registerForm, 'birthYear'); }
    get invalidBirthYear(): boolean {
        return this._isInvalid(this.registerForm, 'birthYear', this.touched);
    }

    get idCard() { return this._formGet(this.registerForm, 'idCard'); }
    get invalidIdCard(): boolean {

        return this._isInvalid(this.registerForm, 'idCard', this.touched);
    }

    get phone() { return this.registerForm.get('phone'); }
    get invalidPhone(): boolean {
        return this._isInvalid(this.registerForm, 'phone', this.touched);
    }

    private _formInit(): void {

        this.allYears = this.getLastOneHundredYears();
        this.allMonths = this.getMonths();

        // Reset for hide form errors
        this.touched = true;

        // Crear la configuración 
        const formGroupConfig = {
            firstName: new UntypedFormControl(
                this.user.name,
                [Validators.required]
            ),
            lastName: new UntypedFormControl(
                this.user.lastName,
                [Validators.required]
            ),
            birthYear: new UntypedFormControl(
                2014,
                [Validators.required, Validators.min(1)]
            ),
            birthMonth: new UntypedFormControl(
                0,
                [Validators.required, Validators.min(1)]
            ),
            birthDay: new UntypedFormControl(
                0,
                [Validators.required, Validators.min(1)]
            ),
            genderType: new UntypedFormControl(
                0,
                [Validators.required, Validators.min(1)]
            ),
            idCardType: new UntypedFormControl(
                1,
                // Requerido solo para Costa Rica
                this.user.country == Country.CR ? [Validators.required, Validators.min(1)] : []
            ),
            idCard: new UntypedFormControl(
                '',
                // Requerido solo para Costa Rica
                this.user.country == Country.CR ? [Validators.required] : []
            ),
            phone: new UntypedFormControl(
                `${this.user.phone}`,
                []
            ),
        };

        // Agregar campos dinámicos segun el pais
        this.geoDataStructure.forEach((element) => {
            formGroupConfig[element.key] = new UntypedFormControl(
                0,
                [Validators.required, Validators.min(1)]
            );
        });

        // Inicializar el formulario con la configuración completa
        this.registerForm = this.formBuilder.group(formGroupConfig);
    }


    validIdCard() {

        if (this.idCardType.value == IdCardCustomerType.Nacional) {

            // Nacional
            this.idCard.setValidators([]);
            this.idCard.setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(15)]);
            this.dynamicMask = 'AAAAAAAAAAAAAAA';
            this.dynamicType = 'text';

        } else if (this.idCardType.value == IdCardCustomerType.Dimex) {

            // DIMEX
            this.idCard.setValidators([]);
            this.idCard.setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(15)]);
            this.dynamicMask = 'AAAAAAAAAAAAAAA';
            this.dynamicType = 'text';

        } else if (this.idCardType.value == IdCardCustomerType.Foreign) {

            // Extranjero
            this.idCard.setValidators([]);
            this.idCard.setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(15)]);
            this.dynamicMask = 'AAAAAAAAAAAAAAA';
            this.dynamicType = 'text';
        }
    }

    validIdCardPanama() {

        // Limpiar validadores previos
        this.idCard.setValidators([]);

        // Requerido solo para Costa Rica
        if (this.user?.country == Country.PA) return;

        // Cédula
        if (Number(this.idCardType.value) === 1) {

            this.idCard.setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(15)]);
            this.dynamicMask = 'AAAAAAAAAAAAAAA'; // Máscara para 8 dígitos de la cédula panameña
            this.dynamicType = 'text';

            // Pasaporte    
        } else if (Number(this.idCardType.value) === 2) {

            this.idCard.setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(15)]);
            this.dynamicMask = 'AAAAAAAAAAAAAAA'; // Máscara alfanumérica para pasaporte
            this.dynamicType = 'text';

            // Carné de Residente Permanente
        } else if (Number(this.idCardType.value) === 3) {

            this.idCard.setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(15)]);
            this.dynamicMask = 'AAAAAAAAAAAAAAA'; // Máscara para 8-12 dígitos del carné de residente
            this.dynamicType = 'text';
        }

        // Revalidar el control para aplicar nuevas configuraciones
        this.idCard.updateValueAndValidity();
    }

    changeBirthYear() {
        this._getDaysByMonthYear(Number(this.registerForm.controls.birthYear.value), Number(this.registerForm.controls.birthMonth.value));
    }

    changeBirthMonth() {

        this._getDaysByMonthYear(Number(this.registerForm.controls.birthYear.value), Number(this.registerForm.controls.birthMonth.value));
    }

    // End Form

    getLastOneHundredYears(): number[] {
        const currentYear = 2015;
        const years = [];

        for (let i = currentYear; i > currentYear - 100; i--) {
            years.push(i);
        }

        return years;
    }

    getLastYearsUntil2015(): number[] {
        const currentYear = new Date().getFullYear();
        const startYear = currentYear > 2015 ? 2015 : currentYear;
        const years = [];

        for (let i = startYear; i > startYear - 100 && i >= 2015; i--) {
            years.push(i);
        }

        return years;
    }


    getMonths(): string[] {

        const months = [
            "Ene", "Feb", "Mar", "Abr", "May", "Jun",
            "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
        ];
        return months;

    }


    private _getDaysByMonthYear(year: number, month: number): void {
        const fecha = new Date(year, month - 1, 1);
        fecha.setMonth(fecha.getMonth() + 1);
        fecha.setDate(fecha.getDate() - 1);
        let daysByMonth = Number(fecha.getDate());
        this.dayList = [];

        for (let index = 0; index < daysByMonth; index++) {
            this.dayList.push(index);
        }
    }
}
